import { FileKind } from "../../../../define/FileKind";
import { BaseLocalListData } from "../../base/BaseLocalListData";

/** 武将数据 */
class OfficerData{
    /** 武将唯一id */
    id: string = '';
    /** 镇守率加成 */
    addGarrison: number = 0;
    /** 是否丢失 */
    bDrop: boolean = false;
    /** 当前镇守城池 */
    curGarrisonCity: string = '';
}

export default class MilitaryOfficerData extends BaseLocalListData {
    lists = new Map<string, OfficerData>();

    /** 最后一次刷新时间 */
    lastRefreshDate: string = '';
    /** 军官列表 */
    curOfficerList: string[] = [];

    /** 已经购买过一次的武将id */
    yetBuyOfficerList: string[] = [];
   
    protected localKey: string = FileKind.SaveLocalDataKey.MILITARY_OFFICER_DATA;

    createItem(key: string): OfficerData {
        return this.createItemT<OfficerData>(OfficerData, key);
    }
}
